import { partnerTypeByPhone } from '../../../www/site/dvs/controllers/dvsKeys.js';

export const partnerType = {
    rdc: 'rdc',
    zumper: 'zumper',
    apartment: 'apartment',
    veterans: 'veterans',
    alliance: 'alliance',
    realtor: 'realtor',
    proplus: 'proplus',
    exp: 'exp',
    zoocasa: 'zoocasa',
    movoto: 'movoto',
};

export const fallbackPartner = {
    partnerId: 'movoto',
    partnerName: 'Movoto',
    partnerType: 'provider',
    condition: 'fallback',
};

export const partnerName = {
    alliance: 'alliance_realty',
    veterans: 'veterans_united',
    zoocasa: 'zoocasa',
};

const GENERIC_MORTGAGE_AGGREGATOR_LENDERS = {
    lenders: [
        {
            lenderName: 'My Cool Lender',
            primaryPhone: '+15559876787',
            staticUrl: 'https://my.cool.lender.biz',
        },
        {
            lenderName: 'My Cool Lender 2',
            primaryPhone: '+15559876789',
            staticUrl: 'https://my.cool.lender2.biz',
        },
    ],
    redirectUrl: 'https://this.is.a.redirect.url/gogogo',
    responseReceivedAt: '2022-11-08T17:23:20.250Z',
};

const getLenderProgramId = (partnerKey) => partnerName[partnerKey] ?? partnerKey;

export const getMockLenderResponse = (partnerKey, { apiName } = {}) => {
    if (apiName === 'mortgageAggregatorByConsumer') {
        return { ...GENERIC_MORTGAGE_AGGREGATOR_LENDERS };
    }
    return { referred: true, programId: getLenderProgramId(partnerKey) };
};

export const getMockLenderResponseForPhone = (phone, { apiName } = {}) => {
    const mockKey = partnerTypeByPhone(phone);
    if (mockKey) {
        return getMockLenderResponse(mockKey, { apiName });
    }
    return null;
};
